import {handleActions} from 'redux-actions';
import {format} from 'date-fns';
import capitalize from 'capitalize';

import {USERS_SET} from './UsersActions';
import {
    UserOption,
    UsersState,
    UsersPayload,
    User,
    UserListAction,
} from '../UsersTypes';

export function stringifyArray(prev: string, next: string, i: number, array: string[]): string {
    let symbol = '';
    
    if (array.length === 0 || i === array.length - 1)
        return `${prev}${next}${symbol}`;
    
    symbol = ', ';
    
    return `${prev}${next}${symbol}`;
}

export const lastLogin = (timestamp: string | null): string => timestamp ? format(new Date(timestamp), 'PPp') : '';
export const getUserStatus = (status?: string): string => status ? capitalize(status.toLowerCase()) : '';
export const getUserRoles = (roles?: string[]): string => {
    const rolesLabel = [];
    
    if (!roles || !roles.length)
        return 'Role not set';
    
    if (roles.includes('contentOpsCoordinator')) {
        rolesLabel.push('Content Operations Coordinator');
    }
    
    if (roles.includes('qcOperator')) {
        rolesLabel.push('QC Operator');
    }
    
    if (roles.includes('admin')) {
        rolesLabel.push('Admin');
    }
    
    if (roles.includes('default')) {
        rolesLabel.push('Default');
    }
    
    return rolesLabel.reduce(stringifyArray, '');
};

export const mapUser = (user: UserOption): User => ({
    ...user,
    rolesStr: getUserRoles(user.roles),
    status: getUserStatus(user.status),
    lastLoginAt: lastLogin(user.lastLoginAt),
});

export const setUsers = (state: UsersState, action: UserListAction): UsersState => {
    const {rows, total} = action.payload;
    
    if (rows) {
        const rowsMapped: UserOption[] = rows
            .map(mapUser);
        
        return {
            total,
            rows: rowsMapped,
            isLoading: false,
        };
    }
    
    return {
        ...initialState,
        isLoading: false,
    };
};

export const initialState: UsersState = {
    rows: [],
    total: 0,
    isLoading: true,
};

const handlers = {
    [USERS_SET]: setUsers,
};

export default handleActions<UsersState, UsersPayload>(handlers, initialState);
